module.exports = __webpack_public_path__ + "img/s-e_indicators.15e19efc.png";